'use client'

import { PriceMode } from '@/utils/loan-calculator'
import { motion } from 'motion/react'

export default function PriceTypeToggle({
  priceMode,
  setPriceMode,
}: {
  priceMode: PriceMode
  setPriceMode: React.Dispatch<React.SetStateAction<PriceMode>>
}) {
  const tabs = [
    { id: 'gross' as PriceMode, label: 'Gross Amount' },
    {
      id: 'net' as PriceMode,
      label: (
        <>
          <span className="hidden sm:block">Net Amount (no included VAT)</span>
          <span className="sm:hidden">Net (no inc. VAT)</span>
        </>
      ),
    },
  ]

  return (
    <div>
      <div className="flex justify-end space-x-1">
        <div className="rounded-full bg-gray-200 p-1">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setPriceMode(tab.id)}
              type="button"
              className={`${
                priceMode === tab.id ? '' : 'hover:text-black/60'
              } relative rounded-full px-3 py-1.5 text-sm font-medium text-black -outline-offset-2 outline-black transition focus-visible:outline-2`}
              style={{
                WebkitTapHighlightColor: 'transparent',
              }}
            >
              {priceMode === tab.id && (
                <motion.span
                  layoutId="bubble"
                  className="absolute inset-0 z-10 bg-white mix-blend-difference"
                  style={{ borderRadius: 9999 }}
                  transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
                />
              )}
              {tab.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
